module.exports = __webpack_public_path__ + "static/media/0210_IMG_LE_SOL_MEGALITH_MEGABLACK.e6b3d6ad.webp";